<script setup>
import { defineProps, defineEmits, computed} from "vue";
import TabelaDeItensDeItem from "./ItensDeItens/TabelaDeItensDeItem.vue"

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "itemDeItem",
]);

const emits = defineEmits([
    "update:alteraItem",
]);

//==================================================================//
//====================== Altera Pagamento ==========================//
//==================================================================//

const alteraItem = (update)=>{

    emits('update:alteraItem',update);

};

//==================================================================//
//======================= Mostra Pagamentos ========================//
//==================================================================//

let mostraSubItens = computed(()=>{

    if(props?.item?.itensQuantidade <= 0){
        return false;
    }

    if(props?.item?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraSubItens"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeItensDeItem
                    :dado="props?.dado"
                    :item="props?.item"
                    :itemDeItem="props?.itemDeItem"
                    @update:alteraItem="alteraItem"
                ></TabelaDeItensDeItem>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
